import { useQuery } from '@apollo/client';
import { QueryHookOptions } from '@apollo/client/react/types/types';
import gql from 'graphql-tag';

import { ValidateInvoiceablePeriodSignature } from '../../../athena/types/ValidateInvoiceablePeriodSignature';

export const VALIDATE_INVOICEABLE_PERIOD_SIGNATURE = gql`
  query ValidateInvoiceablePeriodSignature(
    $startPeriod: String!
    $endPeriod: String!
    $signature: String!
    $orgId: String!
  ) {
    webMaintenance {
      validateInvoiceablePeriodSignature(
        input: {
          startPeriod: $startPeriod
          endPeriod: $endPeriod
          signature: $signature
          organizationId: $orgId
        }
      ) {
        validated
      }
    }
  }
`;

const useValidateInvoiceablePeriodSignature = (
  options?: QueryHookOptions<ValidateInvoiceablePeriodSignature>,
) => useQuery<ValidateInvoiceablePeriodSignature>(VALIDATE_INVOICEABLE_PERIOD_SIGNATURE, options);

export default useValidateInvoiceablePeriodSignature;
